import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FA = ({color, ...rest}) => {
  return <FontAwesomeIcon {...rest} color={color || "gray"} />
}

export default FA;
